// extracted by mini-css-extract-plugin
export var alignBaseline = "_11-9";
export var alignCenter = "_11-5";
export var alignFlexEnd = "_11-7";
export var alignFlexStart = "_11-6";
export var alignSelfBaseline = "_11-e";
export var alignSelfCenter = "_11-a";
export var alignSelfFlexEnd = "_11-c";
export var alignSelfFlexStart = "_11-b";
export var alignSelfStretch = "_11-d";
export var alignStretch = "_11-8";
export var column = "_11-2";
export var columnReverse = "_11-4";
export var flex = "_11-0";
export var justifyCenter = "_11-f";
export var justifyFlexEnd = "_11-h";
export var justifyFlexStart = "_11-g";
export var justifySpaceAround = "_11-j";
export var justifySpaceBetween = "_11-i";
export var justifySpaceEvenly = "_11-k";
export var row = "_11-1";
export var rowReverse = "_11-3";
export var wrapNowrap = "_11-m";
export var wrapWrap = "_11-l";
export var wrapWrapReverse = "_11-n";